import React, { useState } from 'react';
import { CheckCircle, Mail, ArrowLeft, RotateCcw } from 'lucide-react';

const RegistrationSuccess = ({ email, onClose, onResendEmail }) => {
  const [isResending, setIsResending] = useState(false);
  const [resendMessage, setResendMessage] = useState('');

  const handleResendEmail = async () => {
    setIsResending(true);
    setResendMessage('');
    
    try {
      const result = await onResendEmail();
      if (result.success) {
        setResendMessage('Verification email sent! Please check your inbox.');
      } else {
        setResendMessage('Failed to send email. Please try again.');
      }
    } catch (error) {
      setResendMessage('An error occurred. Please try again.');
    } finally {
      setIsResending(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full p-8 text-center">
        <div className="mb-6">
          <CheckCircle className="w-16 h-16 text-green-500 mx-auto mb-4" />
          <h1 className="text-2xl font-bold text-gray-900 mb-2">Account Created!</h1>
          <p className="text-gray-600 mb-4">
            Your account has been created successfully. We've sent a verification email to:
          </p>
          <p className="text-videbits-600 font-semibold mb-6">{email}</p>
          <div className="bg-videbits-50 border border-videbits-200 rounded-lg p-4 mb-6">
            <p className="text-videbits-800 text-sm">
              <Mail className="w-4 h-4 inline mr-2" />
              Please check your email and click the verification link to complete your registration.
            </p>
          </div>
        </div>

        <div className="space-y-3">
          <button
            onClick={handleResendEmail}
            disabled={isResending}
            className="w-full bg-videbits-600 text-white py-3 px-4 rounded-lg hover:bg-videbits-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed font-medium flex items-center justify-center"
          >
            {isResending ? (
              <RotateCcw className="w-5 h-5 mr-2 animate-spin" />
            ) : (
              <Mail className="w-5 h-5 mr-2" />
            )}
            {isResending ? 'Sending...' : 'Resend Verification Email'}
          </button>
          
          {resendMessage && (
            <div className={`p-3 rounded-lg text-sm ${
              resendMessage.includes('sent') 
                ? 'bg-green-50 border border-green-200 text-green-700'
                : 'bg-red-50 border border-red-200 text-red-700'
            }`}>
              {resendMessage}
            </div>
          )}
          
          <button
            onClick={onClose}
            className="w-full bg-videbits-100 text-videbits-700 py-3 px-4 rounded-lg hover:bg-videbits-200 transition-colors font-medium flex items-center justify-center"
          >
            <ArrowLeft className="w-5 h-5 mr-2" />
            Close
          </button>
        </div>

        <div className="mt-6 pt-4 border-t border-gray-200">
          <p className="text-xs text-gray-500">
            Didn't receive the email? Check your spam folder or try resending.
          </p>
        </div>
      </div>
    </div>
  );
};

export default RegistrationSuccess;
